import React from 'react';

export default function Marquee() {
  const items = ['Administrative Support', 'Customer Service', 'Technical Support', 'Creative Services', 'Lead Generation', 'Executive Assistance'];

  return (
    <section className="py-8 bg-[#050A08] border-y border-emerald-500/10 overflow-hidden" data-testid="marquee-section">
      <div className="flex whitespace-nowrap">
        <div className="flex animate-marquee items-center">
          {[...items, ...items].map((item, i) => (
            <div key={i} className="flex items-center">
              <span className="font-display text-2xl md:text-3xl font-bold text-slate-500 px-8">{item}</span>
              <span className="w-2 h-2 rounded-full bg-emerald-400" />
            </div>
          ))}
        </div>
        <div className="flex animate-marquee items-center" aria-hidden="true">
          {[...items, ...items].map((item, i) => (
            <div key={i} className="flex items-center">
              <span className="font-display text-2xl md:text-3xl font-bold text-slate-500 px-8">{item}</span>
              <span className="w-2 h-2 rounded-full bg-emerald-400" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
